import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog13.css';
import blogImage from '../Asets/Blog.jpg';        // hero background
import familyImg from '../Asets/blog1313.png';    // detail image
import Header from '../components/header';
import Footer from '../components/footer';

const Blog13 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            The reason why quality preschools are on the rise among the working parents in India.
          </h2>
          <br />
          <div className="published-badge">Published on: 03 October 2025</div>
          <br />

          <img
            src={familyImg}
            alt="Quality preschools for working parents in India - Red School House Vadodara"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              In the present-day world, which is highly dynamic, there are increasing numbers of parents in India who are combining
              their high-speeding careers and raising young children. This has led to an increased demand of good preschools where
              children are able to learn, develop and flourish in a secure, protecting environment.
            </p>
            <p>
              We have known in <strong>Red School House Vadodara</strong>, which has been rated to be among the <strong>best preschools in Vadodara</strong>,
              the special needs working parents have—and we have developed a preschool program to meet the needs of both children and parents.
            </p>

            <h3>Preschools Changing Role in India</h3>
            <p>
              In India, it used to be a long standing practice in which preschools were perceived as mere child care centers.
              However, today parents are seeking out a lot more. They desire an environment in which their children do not merely
              remain safe as long as they can work, but also acquire <strong>confidence, curiosity and social skills</strong> that will enable them
              to do so in the future. That is why the contemporary preschools such as Red School House Vadodara have become the
              indispensable companion of working parents.
            </p>

            <h3>The Reasons Why Working Parents Select Good Preschools</h3>

            <h3>🛡️ Healthy & Secure Environment</h3>
            <p>
              Parents should be at ease with the thought that they leave their child in a safe and nurturing environment when they
              are away at work. <strong>Safety and supervision</strong> is the priority at Red School House, and this will provide the parents
              with a stress-free experience.
            </p>

            <h3>📚 Early Learning & Development</h3>
            <p>
              Quality preschools are not just about babysitting. They expose children to basic education through imaginative means;
              <strong> letters, numbers, problem solving and creative thinking</strong>.
            </p>

            <h3>🤝 Social & Emotional Growth</h3>
            <p>
              In the modern world, <strong>social skills</strong> are equal to academics. Playing with others will also teach the child to be a
              team player, to have empathy, and to be confident—qualities that will serve them in life.
            </p>

            <h3>⏱️ Variable Assistance to Families</h3>
            <p>
              There are lots of working parents who value the time-conforming preschools. <strong>Red School House Vadodara</strong> offers programs
              that are flexible and friendly to families and therefore, parents are able to maintain both parenting and career.
            </p>

            <h3>The Specialty of Red School House Vadodara</h3>
            <ul>
              <li><strong>Student centred learning:</strong> individual instructions to each child.</li>
              <li><strong>Whole-person development:</strong> combination of academics, creativity and life skills.</li>
              <li><strong>Secure, supportive environments:</strong> in which children feel safe and encouraged.</li>
              <li><strong>Seasoned teachers:</strong> teachers who support children with patience and thoughtfulness.</li>
            </ul>
            <p>
              We have taken the organized learning and made it a happy place to be and this is the balance that busy professionals
              in India are seeking.
            </p>

            <h3>Conclusion</h3>
            <p>
              The increased workforce in India is changing the face of preschool. Families do not need childcare—they need
              <strong> good early education</strong> that will make the difference between success in life and failure. We are very proud to fulfill
              this requirement by providing one of the <strong>best preschool programs in Vadodara</strong> that will help in the development of
              the children and also provide parents with confidence and peace of mind.
            </p>

            <h3>Ready to Enrol?</h3>
            <p>
              Are you a working parent who is in need of the right preschool? <strong>Admission to Red School House, Vadodara</strong> today and
              provide your child with the kind of head start that they deserve.
            </p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog13;
